import { render, staticRenderFns } from "./carrierInfo.vue?vue&type=template&id=bd7b0fe8&scoped=true&"
import script from "./carrierInfo.vue?vue&type=script&lang=js&"
export * from "./carrierInfo.vue?vue&type=script&lang=js&"
import style0 from "./carrierInfo.vue?vue&type=style&index=0&id=bd7b0fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7b0fe8",
  null
  
)

export default component.exports